import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_LANDING_NAME,
} from '../../../engineering-systems-constants';
import { GalleryListStructure } from '../../../components';

export const SEWERAGE_GALLERY_LIST: GalleryListStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/1.jpg/1.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-1b.jpg/sewerage-1b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-1b.jpg/sewerage-1b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '1.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/2.jpg/2.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-2b.jpg/sewerage-2b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-2b.jpg/sewerage-2b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '2.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/3.jpg/3.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-3b.jpg/sewerage-3b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-3b.jpg/sewerage-3b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '3.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/4.jpg/4.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-4b.jpg/sewerage-4b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-4b.jpg/sewerage-4b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '4.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/5.jpg/5.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-5b.jpg/sewerage-5b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-5b.jpg/sewerage-5b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '5.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/sewerage/popup/6.jpg/6.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-6b.jpg/sewerage-6b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/sewerage/sewerage-6b.jpg/sewerage-6b.jpg`,
    alt: 'Пример установки системы водоснабжения и канализации',
    name: '6.jpg',
  },
];
